import { Button, Divider, Group, Modal, Stack } from '@mantine/core';
import { IconPhoto, IconTrash } from '@tabler/icons-react';
import { useThumbnailGenerator } from '../hooks/useThumbnailGenerator';
import { useEditorStore } from '../store/editorStore';
import { TemplateManager } from './TemplateManager';
import { VariablesPanel } from './VariablesPanel';

export function ItemsList() {
  const items = useEditorStore((state) => state.items);
  const selectedItemId = useEditorStore((state) => state.selectedItemId);
  const deleteItem = useEditorStore((state) => state.deleteItem);
  const selectItem = useEditorStore((state) => state.selectItem);
  
  const {
    isGenerating,
    generatedThumbnail,
    showResult,
    generateThumbnail,
    closeResultModal
  } = useThumbnailGenerator();

  return (
    <div style={{ padding: '10px' }}>
      <Group wrap="wrap" gap="xs" style={{ marginBottom: '10px' }}>
        {items.sort((a, b) => b.zIndex - a.zIndex).map((item) => (
          <Button 
            key={item.id} 
            variant={item.id === selectedItemId ? "filled" : "light"}
            size="xs"
            onClick={(e) => {
              e.stopPropagation();
              selectItem(item.id);
            }}
            rightSection={
              <IconTrash
                size={14} 
                color="red" 
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();
                  deleteItem(item.id);
                }}
              />
            }
          >
            {item.type === 'text' 
              ? (item.content.substring(0, 15) + (item.content.length > 15 ? '...' : ''))
              : item.type === 'auto-image'
                ? `Từ khóa: ${item.content.substring(0, 10)}${item.content.length > 10 ? '...' : ''}`
                : item.type === 'auto-image-prompt'
                  ? `Prompt: ${item.content.substring(0, 10)}${item.content.length > 10 ? '...' : ''}`
                  : item.type === 'variable'
                    ? `Biến: ${item.content}`
                    : item.type === 'ai-text'
                      ? `AI: ${item.content.substring(0, 10)}...`
                      : 'Ảnh'}
          </Button>
        ))}
      </Group>
      
      <Group grow align="center" mb="md">
        <Button
          leftSection={<IconPhoto size={14} />}
          onClick={generateThumbnail}
          loading={isGenerating}
          size="md"
        >
          Sinh ảnh (500 tokens)
        </Button>
        
        <TemplateManager />
      </Group>
      
      <Divider my="md" />
      
      <VariablesPanel />

      {/* Modal result */}
      <Modal
        opened={showResult}
        onClose={closeResultModal}
        title="Thumbnail Result"
        size="xl"
      >
        {generatedThumbnail && (
          <Stack>
            <img 
              src={generatedThumbnail} 
              alt="Generated thumbnail" 
              style={{ width: '100%', height: 'auto' }}
            />
            <Button
              component="a"
              href={generatedThumbnail}
              download="thumbnail.jpg"
              target="_blank"
            >
              Download
            </Button>
          </Stack>
        )}
      </Modal>
    </div>
  );
} 